<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xv">SEPHARDI, JEWISH, ARGENTINE</a></p><a id="page_xv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Fm04.vue?482bea80